import { AppBar, Layout, LayoutProps } from "react-admin";
import { StyledAppBarComponent } from "../forms/StyledAppBarComponent";
import { UserMenuJwt } from "../components/authorization/UserMenuJwt";

export default (props: LayoutProps) => (
  <Layout {...props} appBar={StyledAppBarComponent} sidebar={() => null} />
);
